export async function getServerFnById(
  _id: string,
  _access: { origin: 'client' | 'server' },
): Promise<any> {}
